module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-database-3.4443e298.svg";